import './jquery.visible.min';
var maxHeight = 0;
var winHeight = 0;
var winWidth = 0;
var mainTop = 0;
var headertop = null;
var fadeableContent;
var fadeableFooter;
var header = null;
var headerLogo = null;
var navi = null;
var navTop_bevor = null;
var navHeightOrg = null;
var teaVideo = null;
var intersectionObserver;
var $window = $(window);

var parallax = null;
$(document).ready(function() {
    header = document.getElementById('header');
    navHeightOrg = parseInt($('#navigation').outerHeight());
    headertop = document.getElementById('headertop');
    headerLogo = document.getElementById('headerlogo');
    navi = $('#navigation');
    winHeight = $(window).height();
    winWidth = $(window).width();
    mainTop = parseInt($('#main').css('padding-top'));
    if (window.IntersectionObserver) {
        intersectionObserver = new IntersectionObserver(function(event) {
                event.forEach(function(entry) {
                    if (entry.isIntersecting === true) {
                        entry.target.classList.add("fadeContentIn");
                        intersectionObserver.unobserve(entry.target)
                    }
                })
            }
        )
    }

    aniBgElement();
    if (!intersectionObserver) {
        $window.on("scroll", function(e) {
            fadeContent();
            aniBgElement();
        })
    }
    $(window).on('scroll', function() {
        aniBgElement();
        aniScroller();
    })

    initFadeContent();
    setTimeout(function() {
        initContent();
        aniScroller();
    }, 100);
});

function aniScroller() {
    var newWidth = ((window.scrollY) / (document.body.clientHeight - window.innerHeight)) * 100;
    $('#filler').css('width', newWidth+'%');
}

function makeMenue() {
    teaVideo = $('#teaVideo');
    if(teaVideo.length) {
        var vidHeight = teaVideo.outerHeight();
        var newTop = 0;
        if(vidHeight > $(window).outerHeight()) {
            newTop = $(window).outerHeight() - 65;
        } else {
            newTop = vidHeight - 65;
            $('main>.grid-container').first().css('padding-top', $('#navigation').outerHeight() + 20);
        }

        // $('#navigation').css('top', newTop);
        // $('#navigation').css('opacity', 1);
    }
}

function fadeContent() {
    var offset = $window.scrollTop() + $window.height();
    $.each(fadeableContent, function(i, v) {
        if ($(v).data().top < offset) {
            $(v).addClass("fadeContentIn")
        }
    });
    if (fadeableFooter.data().top < offset) {
        fadeableFooter.addClass("fadeContentIn")
    }
}

function initContent() {
    var iconname = '';
    var pfad = '';
    navTop_bevor = parseInt(navi.css('top'));
    maxHeight = document.body.clientHeight;
    $('img[usemap]').rwdImageMaps();
    $('.fontawsome-icon').each(function() {
        iconname = $(this).data('iconname');
        pfad = $(this).children().attr('src');
        $(this).load(pfad);
    });
    $('#teaVideo .active h1').css('left', '0px');
    $('#teaVideo .active p').css('left', '0px');
    setTimeout(function() {
        parallaxGallery();
    }, 5000);
    if(winWidth > 1024)
        aniMenue();

    initTeaserSlider(true);
    $(window).on('scroll', function() {
        if(winWidth > 1024) {
            aniMenue();
        }
    });

    var tvideo = $('#teaservideo');
    if($(window).outerWidth() < 768 && tvideo.data('srcmobile') != '') {
        tvideo.attr('src', tvideo.data('srcmobile'));
    } else {
        tvideo.attr('src', tvideo.data('src'));
    }
    if(tvideo[0] !== undefined)
        tvideo[0].load();
}


function parallaxText(scrollTop) {
    var tmp = scrollTop / 1.5;
    var fensterHoehe = window.innerHeight;
    $('.teaser-texte').each(function() {
        var tmpObj = $(this);
        var outterObject = tmpObj.parent().parent();

        var offset = outterObject.offset().top;
        var hoehe = outterObject.height();

        var newHeight = 0;
        if(offset < fensterHoehe) {
            newHeight = tmp;
            $(this).css('transform', 'translateY(calc(-50% + '+(newHeight)+'px))');
        } else {
            if((offset - fensterHoehe) < scrollTop) {
                var nullWert = offset - fensterHoehe - hoehe;
                newHeight = tmp - nullWert;
                $(this).css('transform', 'translateY(calc(-50% + '+(newHeight)+'px))');
            }
        }
    });
}

function aniMenue() {
   var winTop = parseInt(window.scrollY);
   parallaxText(winTop)
}

function parallaxGallery() {
    var objekte = document.getElementsByClassName('parallax-gallery-inner');

    Array.prototype.forEach.call(objekte, function(el) {
        var bilder = el.children;
        var i = 1;
        var max = bilder.length;
        var firstEl = '';
        var nextOn = false;
        Array.prototype.forEach.call(bilder, function(bild) {
           if(firstEl == '') {
               firstEl = bild;
           }
           if(nextOn == true) {
               bild.classList.add('active');
               nextOn = false;
           } else {
               if(bild.classList.contains('active') && i < max) {
                   bild.classList.remove('active');
                   nextOn = true;
               } else if(bild.classList.contains('active') && i >= max && max > 1) {
                   firstEl.classList.add('active');
                   bild.classList.remove('active');
               }
           }
           i++;
        });
    });

    setTimeout(function() {
        parallaxGallery();
    }, 5000);
}

var bgElement;
var bgElementOffset;
var bgElementWindowHeight;
var photoViewportOffsetTop;
var photoViewportOffsetLeft;
var photoViewportOffsetRight;
var bgElementNewPos;
function aniBgElement() {
    $('.backgroundelement').each(function() {
        bgElement = $(this);
        bgElementOffset = bgElement.offset()
        bgElementWindowHeight = $(window).outerHeight();
        photoViewportOffsetTop = bgElementOffset.top - $(document).scrollTop();
        // var photoViewportOffsetLeft = bgElementOffset.left - $(document).scrollLeft();
        bgElementNewPos = (photoViewportOffsetTop - bgElementWindowHeight) / 30;

        if(bgElement.hasClass('backgroundelement_right')) {
            bgElement.css('margin-right', bgElementNewPos + 'px');
        } else {
            bgElement.css('margin-left', bgElementNewPos + 'px');
        }
    });
}

function initFadeContent() {
    fadeableContent = $("main").find(".fadeing").not(".no-fade");
    if (!intersectionObserver) {
        $.each(fadeableContent, function(i, v) {
            $(v).data().top = $(v).offset().top
        });
    } else {
        $.each(fadeableContent, function(i, v) {
            intersectionObserver.observe(v)
        });
    }
}

function initTeaserSlider(start = false) {
    if(start !== true) {
        $('#teaserBilder').each(function (index) {
            var tmp = $(this);
            var activeIndex = 0;
            var fertig = false;
            if ($('#teaVideo').visible(true)) {
                tmp.children('.teaser--bg').each(function (index2) {
                    var aktuell = $(this);
                    if (aktuell.hasClass('active') === true && fertig === false) {
                        if (aktuell.next().length) {
                            aktuell.removeClass('active');
                            aktuell.next().addClass('active');
                            fertig = true;
                        } else {
                            aktuell.removeClass('active');
                            aktuell.parent().children(':first').addClass('active');
                            fertig = true;
                        }
                    }
                })
            }
        });
    }
    setTimeout(function() {
        initTeaserSlider();
    }, 5000);
}

/*
* rwdImageMaps jQuery plugin v1.6
*
* Allows image maps to be used in a responsive design by recalculating the area coordinates to match the actual image size on load and window.resize
*
* Copyright (c) 2016 Matt Stow
* https://github.com/stowball/jQuery-rwdImageMaps
* http://mattstow.com
* Licensed under the MIT license
*/
;(function(a){a.fn.rwdImageMaps=function(){var c=this;var b=function(){c.each(function(){if(typeof(a(this).attr("usemap"))=="undefined"){return}var e=this,d=a(e);a("<img />").on('load',function(){var g="width",m="height",n=d.attr(g),j=d.attr(m);if(!n||!j){var o=new Image();o.src=d.attr("src");if(!n){n=o.width}if(!j){j=o.height}}var f=d.width()/100,k=d.height()/100,i=d.attr("usemap").replace("#",""),l="coords";a('map[name="'+i+'"]').find("area").each(function(){var r=a(this);if(!r.data(l)){r.data(l,r.attr(l))}var q=r.data(l).split(","),p=new Array(q.length);for(var h=0;h<p.length;++h){if(h%2===0){p[h]=parseInt(((q[h]/n)*100)*f)}else{p[h]=parseInt(((q[h]/j)*100)*k)}}r.attr(l,p.toString())})}).attr("src",d.attr("src"))})};a(window).resize(b).trigger("resize");return this}})(jQuery);